import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject, catchError } from 'rxjs';
import { EnvironmentService } from 'src/app/services/environment.service';

export interface AppConfig {
    inputStyle: string;
    colorScheme: string;
    theme: string;
    ripple: boolean;
    menuMode: string;
    scale: number;
    menuTheme: string;
}

interface LayoutState {
    staticMenuDesktopInactive: boolean;
    overlayMenuActive: boolean;
    rightMenuVisible: boolean;
    configSidebarVisible: boolean;
    staticMenuMobileActive: boolean;
    menuHoverActive: boolean;
    searchBarActive: boolean;
    sidebarActive: boolean;
    anchored: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    USER_ENDPOINT = "/users/getConnectedUserInfo";
    BASE_URL = "/ws/rest";
    USER_CHECK_CONTRACTS_ENDPOINT = "/users/check-all-desactivated-contracts";
    CHECK_ADMIN = "/audit/check-admin";
    CHECK_SUPER_ADMIN = "/audit/check-super-admin";

    constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

    config: AppConfig = {
        ripple: true,
        inputStyle: 'outlined',
        menuMode: 'compact',
        colorScheme: 'light',
        theme: 'blue',
        scale: 14,
        menuTheme: 'darkgray'
    };

    state: LayoutState = {
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        rightMenuVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        searchBarActive: false,
        sidebarActive: false,
        anchored: false
    };

    private configUpdate = new Subject<AppConfig>();

    private overlayOpen = new Subject<any>();

    configUpdate$ = this.configUpdate.asObservable();

    overlayOpen$ = this.overlayOpen.asObservable();

    onMenuToggle() {
        if (this.isOverlay()) {
            this.state.overlayMenuActive = !this.state.overlayMenuActive;

            if (this.state.overlayMenuActive) {
                this.overlayOpen.next(null);
            }
        }

        if (this.isDesktop()) {
            this.state.staticMenuDesktopInactive = !this.state.staticMenuDesktopInactive;
        }
        else {
            this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive;

            if (this.state.staticMenuMobileActive) {
                this.overlayOpen.next(null);
            }
        }
    }

    onOverlaySubmenuOpen() {
        this.overlayOpen.next(null);
    }

    showRightMenu() {
        this.state.rightMenuVisible = true;
    }

    showConfigSidebar() {
        this.state.configSidebarVisible = true;
    }

    toggleSearchBar() {
        this.state.searchBarActive = !this.state.searchBarActive;
    }

    isOverlay() {
        return this.config.menuMode === 'overlay';
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isSlim() {
        return this.config.menuMode === 'slim';
    }

    isCompact() {
        return this.config.menuMode === 'compact';
    }

    isHorizontal() {
        return this.config.menuMode === 'horizontal';
    }

    isMobile() {
        return !this.isDesktop();
    }

    onConfigUpdate() {
        this.configUpdate.next(this.config);
    }

    public checkIfAllContractsAreDesactivated(): Observable<any> {
        return this.http.get<boolean>(this.environmentService.get().serverUrl + this.BASE_URL + this.USER_CHECK_CONTRACTS_ENDPOINT)
    }

    public checkIfAdmin(): Observable<any> {
        return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + this.CHECK_ADMIN)
    }

    public checkIfSuperAdmin(): Observable<any> {
        return this.http.get<any>(this.environmentService.get().serverUrl + this.BASE_URL + this.CHECK_SUPER_ADMIN)
    }
}
